export * from "./legacy";
export {
    contactsApi,
    useGetContactsQuery,
    useGetContactByIdQuery,
    useSetContactArchivedMutation,
} from "./rtk";
